import React from "react";
import { AgentsHero, AgentsColoredBlobBackground, AgentsHeroMobile } from "components/platform/agents";
import { Box } from "@chakra-ui/react";

type AgentsHeroAnimationProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function AgentsHeroAnimation({ eyebrow, title, description }: AgentsHeroAnimationProps) {
  return (
    <Box>
      <AgentsColoredBlobBackground />

      {/* web stuff */}
      <Box display={{ base: "none", lg: "block" }}>
        <AgentsHero eyebrow={eyebrow} title={title} description={description} />
      </Box>
      {/* mobile stuff */}
      <Box display={{ base: "block", lg: "none" }}>
        <AgentsHeroMobile eyebrow={eyebrow} title={title} description={description} />
      </Box>
    </Box>
  );
}
